import React from 'react'
import { SvgIcon } from '@mui/material'

export const BrightnessIcon = () => (
  <SvgIcon
    viewBox="0 0 16 16"
    sx={{ height: '16px', width: '16px', color: 'white' }}
  >
    <g clipPath="url(#BrightnessIconUrlA)">
      <path
        fill="#fff"
        d="M8 12V4a4 4 0 0 1 0 8Zm5.333-1.793L15.54 8l-2.207-2.207V2.667h-3.126L8 .46 5.793 2.667H2.667v3.126L.46 8l2.207 2.207v3.126h3.126L8 15.54l2.207-2.207h3.126v-3.126Z"
      />
    </g>
    <defs>
      <clipPath id="BrightnessIconUrlA">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
)
